<script>
    import SubscribeForm from "@miku-kz/components/SubscribeForm";

    export default {
        name: "Newsletter",
        components: {
            SubscribeForm,
        },
    };
</script>

<template>
    <div class="newsletter">
        <div class="newsletter__inner">
            <div class="newsletter__title">
                Оставайтесь в курсе событий с нашими ежемесячными рассылками
            </div>
            <div class="newsletter__form">
                <subscribe-form></subscribe-form>
            </div>
        </div>
    </div>
</template>

<style lang="scss">
    .newsletter {
        position: relative;
        margin: 0 -16px;
        &::before {
            content: "";
            @include center-absolute(0);
            background-image: url("/static/miku-kz/recipes/background--mobile.svg");
            background-size: cover;
            pointer-events: none;
        }
        @include bp($bp-desktop-sm) {
            margin: 0;
            &::before {
                background-image: url("/static/miku-kz/recipes/background.svg");
            }
        }
    }

    .newsletter__inner {
        margin: 0 16px;
        padding: 24px 16px;
        border: 2px solid var(--input-border-color);
        border-radius: var(--border-lg);
        box-shadow: 0 10px 30px #f2f2f5;
        @include bp($bp-desktop-sm) {
            margin: 0;
            padding: 40px;
        }
    }

    .newsletter__title {
        margin-bottom: 32px;
        padding: 0 8px;
        font-size: 16px;
        font-weight: 700;
        line-height: 24px;
        text-align: center;
        @include bp($bp-desktop-sm) {
            margin-bottom: 24px;
            padding: 0;
            font-size: 20px;
        }
    }

    .newsletter__form {
        @include bp($bp-desktop-sm) {
            max-width: 710px;
            margin: 0 auto;
        }
    }
</style>
